<template>
	<div class="pb-4">

		<div class="float-right">
			<button class="btn btn-success mb-2 ml-2" @click="submitFeedback()">{{ $t('submit-form') }}</button>
		</div>

		<Avatar
			class="avatar d-inline-block align-top mr-4 mb-3 lg:mb-0"
			:userId="feedback.userabout_id"
		/>
		<div class="clearfix d-inline-block align-top">
			<h2 class="mb-0">
				{{ $t('feedback') }}
			</h2>
			<p class="mb-4">
				<template v-if="feedback.user_id != $UserSession.getValue('id')">
					{{ $t('user-colon') }} <strong>{{ feedback.userabout_displayname }}</strong>
				</template>
			</p>
		</div>

		<div class="form-group">
			<label>{{ $t("date-time") }}</label>
			<input
				type="datetime-local"
				v-model="feedback.datetime"
				class="form-control"
				style="max-width:250px"
			/>
		</div>


		<div class="form-group">
			<label>{{ $t("treatment-session") }}</label>
			<select
				v-model="feedback.treatmentsession_id"
				class="form-control"
			>
				<option value="">{{ $t('none') }}</option>
				<option v-for="treatmentsession in treatmentsessions" :value="treatmentsession.id" :key="treatmentsession.id">
					{{ treatmentsession.id }}:
					{{ $datetime.getLocaleStringFromTimeStamp(treatmentsession.treatmentTimestamp) }} |
					{{ treatmentsession.teacher_displayname}} |
					{{treatmentsession.specialtyName}} |
					{{treatmentsession.clinicName}}
				</option>
			</select>
		</div>

		<div class="form-group clearfix">
			<label class="mb-0">{{ $t('feedback') }}</label>
			<p class="small m-0"><strong>{{ $t('your-feedback-will-be-visible-message') }}</strong></p>
			<textarea-autosize
				class="form-control"
				v-model="feedback.content"
			></textarea-autosize>
		</div>

         <!-- Tag Selector -->
            <TagGroups v-model="feedback.tags" class="mb-5" />
    </div>
</template>

<script>
import Avatar from "src/components/Avatar.vue";
import TagGroups from "../../components/Tags/GroupedTagSelector.vue";

export default {
	components: {
		Avatar,
        TagGroups
	},
    data: function() {
        return {
        	feedback: {
				userabout_id:  this.$route.params.userid ,
				userabout_displayname: '' ,
				treatmentsession_id: null ,
				datetime: this.$datetime.getDateTimeLocalFieldNowValue() ,
				content: '',
                tags: []
        	},
        	pageNum: 1,
        	loadingreportview: true,
        	reportHtml: null,
        	loadinghtmlreportview: true,
        	individualReportHtml: null,
        	currentreporttab: 0,
        	treatmentsessions: [],
        }
    },
    mounted() {
    	this.getStudent();
    	this.getTreatmentSessions();
    },
    methods: {
    	getStudent() {
    		this.$users.getDisplayName.call(this , this.feedback.userabout_id).then(student => {
				this.feedback.userabout_displayname =  student;
			});
    	},

    	getTreatmentSessions() {
			this.$cfetch(`${this.$settings.APIBaseURL}/feedbacktext/listtreatmentsessions`, {
				data: {
					studentId: this.feedback.userabout_id
				}
			})
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.treatmentsessions = json.treatmentsessions;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
    	},

    	submitFeedback() {
    		this.$store.commit("showBlockingSpinner");
			this.feedback.datetime = this.$datetime.getTimeStampFromDateTimeField(
				this.feedback.datetime
			);
  			this.$cfetch(`${this.$settings.APIBaseURL}/feedbacktext/save`, {
  				method: 'post',
  				data: this.feedback
  			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");

				if (json.status.toLowerCase() === "success") {
					// form saved
					//this.$router.replace(`/forms/list`);
					this.formSubmitSuccess();
				} else {
					// something went wrong
					this.formSubmitFailed();
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
				this.formSubmitFailed();
			});
    	},


    	formSubmitFailed() {
			this.$store.commit("openDialog", {
				title: this.$t("oops"),
				content: this.$t("feedback-save-failed"),
				confirmCallBack: function() {
				}
			});

    	},
    	formSubmitSuccess() {
			const self = this;
			this.$store.commit("openDialog", {
				title: this.$t("saved"),
				content: this.$t("feedback-saved"),
				confirmCallBack: function() {
					self.$router.replace(`/feedback`);
				}
			});

    	}
    },
    computed: {
    }
}
</script>
